<template>
    <div class="inputWrapper" :style="{ top: (index)*70 + 'px'}" :class="[hideList, toggleList]">
        <div class="inputTitle">{{ title }} <span class="icon-x" :class="toggleList" @click="closeOptions"></span> <span class="icon-rotate-cw" @click="resetOptions" v-show="!showList"></span> </div>
        <div class="optionWrapper">
            <div :class="disabled" class="currentOption" @click="showOptions">{{ (!disableDropdown ? 'Choose ' + orderHelper[this.rankingOptions.length] + ' Ranking Factor' : 'Max choices selected') }}</div>
            <ul class="optionList" :class="toggleList">
                <li v-for="option in options" :key="option" @click="chooseOptions(option)" :class="{'multi': multi, 'selected': selected }">
                    {{ option }}
                </li>
            </ul>
        </div>
        <div :class="(toggleList ? 'hideCurrentFactors' : '')">
            <div class="intro">Ranking factors allow you to select up to {{ maxOptions }} aspects you are most interested in and allows Select to sort them according</div>
            <ul class="currentFactorList">
                <draggable element="li" :list="rankingOptions" @start="drag=true" @end="drag=false">
                    <li v-for="(rank, index) in rankingOptions" :key="index" class="currentFactor"><span>{{orderHelper[index]}}:</span> {{ rank }}<span class="icon-x removeRankingFactor" @click="removeRankingFactor(index)"></span></li>
                </draggable>
            </ul>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
    props: {
        index: {
            required: true,
        },
        options: {
            type: Array,
        },
        title: {
            type: String,
        },
        maxOptions: {
        },
    },
    components: {
        draggable,
    },
    data () {
        return {
            showList: false,
            rankingOptions: ['AOM', 'Test 2'],
            chosen: false,
            orderHelper: ['1st', '2nd', '3rd'],
            optionsList: [],
        };
    },
    created () {
        // this.optionsList = [];
        this.$set(this, 'optionsList', this.options);
    },
    methods: {
        showOptions () {
            if (!this.disableDropdown) {
                this.showList = true;
            }
        },
        closeOptions () {
            this.showList = false;
        },
        resetOptions () {
            this.rankingOptions = [];
            this.$set(this, 'options', this.optionsList);
            // this.options = this.optionsList.slice(0);
        },
        chooseOptions (option, max) {
            this.rankingOptions.push(option);
            const optionIndex = this.options.indexOf(option);
            this.options.splice(optionIndex, 1);
            this.chosen = !this.chosen;
            this.showList = !this.showList;
        },
        removeRankingFactor (index) {
            //
        },
    },
    computed: {
        toggleList () {
            return (this.showList ? 'show' : '');
        },
        hideList () {
            return (!this.showList && this.$store.state.ui.dropdownSelected ? 'hideDropdown' : '');
        },
        disabled () {
            return (this.disableDropdown ? 'disabled' : '');
        },
        disableDropdown () {
            if (this.rankingOptions.length >= (this.maxOptions)) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/all.scss';
.inputWrapper{
    margin-bottom: 10px;
    display: block;
    opacity: 1;
    -webkit-transition: top 0.3s ease-in-out, opacity 0.01s ease;
    -moz-transition: top 0.3s ease-in-out, opacity 0.01s ease;
    -o-transition: top 0.3s ease-in-out, opacity 0.01s ease;
    transition: top 0.3s ease-in-out, opacity 0.01s ease;
    position: absolute;
    width: 100%;
    &.hideDropdown{
        // display: none;
        // visibility: hidden;
        opacity: 0;
    }
    &.show{
        width: 100%;
        height: 100%;
        top: 0 !important;
        z-index: 100;
    }
}
.inputTitle{
        font-size: 18px;
    font-weight: 700;
    color: $darkBlue;
    .icon-x{
        float: right;
        display: none;
        @include easeInOut(0.5s);
        &.show{
            display: block;
            cursor: pointer;
        }
    }
    .icon-rotate-cw{
        float: right;
        cursor: pointer;
    }
}
.optionWrapper{
    position: relative;
    .currentOption{
        font-size: 16px;
        cursor: pointer;
        background-color: rgb(0, 163, 196);
        color: white;
        padding: 6px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &.disabled{
            background-color: $grey!important;
            cursor: default!important;
        }
    }
    .optionList{
        display: none;
        padding-left: 0;
        font-size: 16px;
        min-height: 580px;
        width: 100%;
        li{
            padding: 6px;
            vertical-align: bottom;
            cursor: pointer;
            &:before {
                font-family: 'icomoon' !important;
                content: "\e91c";
                padding-right: 10px;
            }
            &:hover{
                background-color: $darkBlue;
                color: white;
                &:before{
                    content: "\e91a";
                }
            }
            &.multi{
                &:before{
                    content: "\e928";
                }
                &:hover{
                    &:before{
                        content: "\e91b"!important;
                    }
                }
                &.selected{
                    background-color: #002c5c;
                    color: white;
                    &:before{
                        content: "\e91b"!important;
                    }
                }
            }
        }
        position: absolute;
        &.show{
            display: block;
        }
    }

}
.hideCurrentFactors{
        display: none;

    }
    .intro{
            margin-top: 10px;
            font-size: 12px;
        }
.currentFactorList{
        list-style: none;
    padding-left: 0;
    margin: 10px 0;
    .currentFactor{
        padding: 5px 10px;
        background-color: $darkBlue;
        margin-bottom: 5px;
        color: white;
        .removeRankingFactor{
            float: right;
            margin-top: 3px;
            cursor: pointer;
        }
    }
}
</style>
